/* @flow */

import React from 'react';
import { arrowRightIcon } from '../Icons';
import { Pages, Root, StyledArrow, StyledArrowBack, Button } from './styled';
import PageButton from './PageButton';

type TProps = {
	currentPage: number,
	setCurrentPage: () => {},
	totalPosts: number,
	postPerPage: number,
};

const Paginate = ({ currentPage, setCurrentPage, totalPosts, postPerPage }: TProps) => {
	const totalPages = Math.ceil(totalPosts / postPerPage);

	const pages = [];

	for (let p = 1; p <= totalPages; p++) {
		pages.push(p);
	}

	const getPagingRange = (current: number, total: number, limit: number, min: number = 1): Array<number> => {
		const length = limit > total ? total : limit;

		let start = current - Math.floor(limit / 2);
		start = Math.max(start, min);
		start = Math.min(start, min + total - length);

		// Получаем массив длины length, элементы которого начинаются со start [start, start+1, start+2, ...]
		return Array.from({ length }, (el, i) => start + i);
	};

	return (
		<Root>
			{currentPage > 1 && (
				<Pages>
					<Button prev onClick={setCurrentPage(currentPage - 1)} type="button">
						<StyledArrowBack viewBox="0 0 8 16">{arrowRightIcon}</StyledArrowBack>
					</Button>
				</Pages>
			)}
			<Pages>
				{getPagingRange(currentPage, totalPages, 5).map((item) => (
					<PageButton
						key={Math.random()}
						index={item}
						onPageChange={setCurrentPage(item)}
						isActive={item === currentPage}
						dataQa=""
					/>
				))}
			</Pages>
			<Pages>
				{currentPage < totalPages && (
					<Button next onClick={setCurrentPage(currentPage + 1)} type="button">
						<StyledArrow viewBox="0 0 8 16">{arrowRightIcon}</StyledArrow>
					</Button>
				)}
			</Pages>
		</Root>
	);
};

export default Paginate;
